module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "more"
    }
  }, [_c('h1', [_vm._v("more")]), _vm._v(" "), _c('p', [_vm._v("coming soon ...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44bb871f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/More.vue
// module id = 85
// module chunks = 0